import { render, staticRenderFns } from "./ManageEvaluationTable.vue?vue&type=template&id=807020e2&scoped=true"
import script from "./ManageEvaluationTable.vue?vue&type=script&lang=js"
export * from "./ManageEvaluationTable.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=807020e2&prod&scoped=true&lang=css&external"
import style1 from "./ManageEvaluationTable.vue?vue&type=style&index=1&id=807020e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807020e2",
  null
  
)

export default component.exports